import {useContext, useEffect, useState} from "react";
import { Button, Modal, TopNavigation } from "@cloudscape-design/components";
import { TandC } from "../../components/T&C";
import { SignIn } from "./SignIn";
import { SignInIcon } from "../../components/SignInIcon";
import { CheckingLogin } from "../AuthenticationWrapper/AuthMessages";
import { Redeem } from "./Redeem";
import { useNavigate, useSearchParams } from "react-router-dom";
import "@cloudscape-design/global-styles/index.css";
import "./Coupon.css";
import {getAuthenticationContext} from "../../auth/AuthenticationContext";

const QUERY_COUPON_ID_KEY = "id";

export const Coupon = () => {
  const AuthenticationContext = useContext(getAuthenticationContext());
  const [searchParams] = useSearchParams();
  const [showModal, setShowModal] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const coupon_id = searchParams.get(QUERY_COUPON_ID_KEY);

  useEffect(() => {
    if (coupon_id == null) navigate("/");
  }, [coupon_id, navigate]);

  useEffect(() => {
    AuthenticationContext.checkUserLoggedIn()
      .then((_) => {
        setLoggedIn(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        console.error("User is not loggedin");
      });
  }, [AuthenticationContext]);

  if (isLoading) return <CheckingLogin error={false}/>;

  return (
    <div className="coupon--wrapper">
      <Modal
        onDismiss={() => setShowModal(false)}
        visible={showModal}
        closeAriaLabel="Close modal"
        header="Sign In"
      >
        <div className="coupon--modal-content">
          <Button
            onClick={() => AuthenticationContext.redirectToLogin()}
            iconSvg={<SignInIcon />}
          >
            SIGN IN TO AWS SKILL BUILDER
          </Button>
        </div>
      </Modal>
      <TopNavigation
        identity={{
          href: window.location.toString(),
        }}
        utilities={[
          {
            type: "button",
            text: "Explore AWS partner training",
            href: "https://www.aws.training/PartnerTraining",
            external: true,
            externalIconAriaLabel: " (opens in a new tab)",
          },
          {
            type: "button",
            text: "Get certified",
            href: "https://www.aws.training/Certification",
            external: true,
            externalIconAriaLabel: " (opens in a new tab)",
          },
        ]}
        i18nStrings={{
          overflowMenuTitleText: "T&C",
          overflowMenuTriggerText: "T&C",
        }}
      />

      <div className="coupon--header-content">
        <TandC />
        {!loggedIn && (
          <div>
            <Button onClick={() => setShowModal(true)} variant="primary">
              Sign in
            </Button>
          </div>
        )}
      </div>

      <div className="coupon--content-wrapper">
        {!loggedIn && <SignIn setShowModal={setShowModal} />}
        {loggedIn && coupon_id && <Redeem couponId={coupon_id} />}
      </div>
    </div>
  );
};
